// extracted by mini-css-extract-plugin
export var productImage = "_mx-0";